interface LandingChipComingSoonProps {
  /**
   * Chip label – defaults to "COMING SOON" when not provided.
   */
  label?: string
  /**
   * Additional utility classes for the outer wrapper so callers can control
   * absolute positioning, rotation, etc. Leave empty string for default.
   */
  className?: string
}

/**
 * Small angled gradient chip (e.g. "COMING SOON", "COMING LIVE SPORTS MARKETS 🏈").
 *
 * The component purposefully **does not** set its own positioning beyond a
 * simple inline‐block wrapper. This lets each caller decide where and how the
 * chip should overlay its parent via `className`.
 */
export function LandingChipComingSoon({ label = "UP NEXT 📈", className = "" }: LandingChipComingSoonProps) {
  return (
    <div className={className}>
      <div className="bg-linear-to-r from-[#30DFFF] to-[#22FF65] text-[#13161f] text-xs md:text-sm font-extrabold px-[.7rem] py-[.33rem] rounded-sm whitespace-nowrap select-none skew-x-[-16deg]">
        <span className="inline-block skew-x-16">{label}</span>
      </div>
    </div>
  )
}
